`<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <h3 class="text-center">
          <span style="padding: 0 12px;border-left:1px solid;border-right:1px solid;">{{ $t('amtb.title') }}</span>
        </h3>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-breadcrumb style="background-color: transparent;">
          <b-breadcrumb-item :to="{ name: 'index' }">{{ $t('index.title') }}</b-breadcrumb-item>
          <b-breadcrumb-item :to="{ name: 'amtb' }">{{ $t('amtb.title') }}</b-breadcrumb-item>
        </b-breadcrumb>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>基金會</h3>
        <p>
          財團法人華藏耕心教育基金會<br>
          新北市三重區萬全街15號1樓 (241)<br>
          Tel: 02-29750284, 29753454<br>
          Fax: 02-29705785<br>
          網址: http://www.amtb-gx.org.tw/
        </p>
        <p>
          財團法人華藏淨宗弘化基金會<br>
          Corporate Body of Hwa Dzan Pure Land Teachings Propagation Foundation<br>
          台北市大安區信義路四段341號5樓 (106)<br>
          Tel: 02-2754-7178<br>
          Fax: 02-2703-9513<br>
          網址: http://www.hwadzan.com/
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>電視台</h3>
        <p>
          華藏衛星電視台<br>
          臺北郵政第81-867號信箱<br>
          Tel: 02-6600-8968<br>
          Fax: 02-6600-9598<br>
          網址: http://www.hwazantv.com/<br>
          E-Mail: hztvusa@hwazantv.com
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <h3>台北市</h3>
        <p>
          社團法人華藏淨宗學會<br>
          The Corporation Republic of Hwa Dzan Society<br>
          台北市大安區信義路四段333-1號2樓 (110)<br>
          Tel: 02-2754-7178<br>
          Fax: 02-2754-7262<br>
          網址: http://www.hwadzan.tw/ (華藏淨宗協會)<br>
          或 http://www.hwadzan.org.tw/<br>
          http://www.amtb.org.tw (淨空法師專集網站)<br>
          E-mail: amtb@hwadzan.com<br>
          法寶申請專用信箱: hwadzan@amtb.org.tw
        </p>
        <p>
          台北淨宗學會<br>
          台北市南京東路三段269巷6號1樓 (105)<br>
          Tel: 02-2719-2087~9<br>
          Fax: 02-2546-9706<br>
          網址: http://www.amtb-taipei.org/<br>
          E-mail：amtb@amtb-taipei.org
        </p>
        <p>
          明德淨宗學會<br>
          台北市北投區明德路96號1樓 (112)<br>
          Tel: 02-2828-7577<br>
          Fax: 02-2828-7578
        </p>
        <p>
          七堵淨宗念佛會<br>
          會址：台北市士林區後港街20巷20號2樓<br>
          Tel: 02-2885-3876, 0937-021584<br>
          Fax: 02-2885-3876<br>
          網址: http://www.chidu-amtb.org/<br>
          E-mail：canaancc@ms28.hinet.net
        </p>
        <p>
          七堵淨宗念佛會　長安道場<br>
          會址：基隆市七堵區長安街31號・長安活動中心（百福車站銜接）<br>
          Tel: 0937-021-584
        </p>
        <p>
          中華法藏淨宗學會<br>
          會址：台北市中山區民權東路二段118號2樓 (104)<br>
          Tel: 02-2568-3076<br>
          Fax: 02-2568-1920<br>
          網址: https://www.igiving.org.tw/npo/introduce?n_id=16<br>
          E-mail：amtb919@yahoo.com.tw
        </p>
        <p>
          台北阿彌陀佛淨宗學會<br>
          會址：台北市信義區福德街137巷11弄4號2樓 (11078)<br>
          Tel: 02-2727-0635、0921-159-000<br>
          E-mail：tpeamtb7779@yahoo.com.tw
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

import { BreadcrumbPlugin } from 'bootstrap-vue'

import i18n from '@/plugins/i18n.js'

Vue.use(BreadcrumbPlugin)

export default {
  i18n,
  name: 'amtb',
  props: {
    // 
  },
  data() {
    return {
      // 
    }
  },
  methods: {
    // 
  },
  created() {
    // alert(`Vue version : ${Vue.version}`)
  },
  components: {
    // 
  },
  metaInfo() {
    return {
      title: this.$t('amtb.title'),
      meta: [{
        vmid: 'description',
        name: 'description',
        content: ''
      }]
    }
  }
}
</script>